export default __webpack_public_path__ + "static/media/close-icon.fd1c1afb.svg";